import React, { useState } from "react";
import { useDocTitle } from "../utils/hooks";
import WithMainLayout from "../hocs/layouts/MainLayout";
import GlobalLoading from "./common/GlobalLoading";

function CrecerMas() {
  useDocTitle("CrecerMas");
  const [isLoading, setIsLoading] = useState(true);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  const crecerMasUrl = process.env.REACT_APP_CRECER_MAS_URL || "http://afpsti29:8081/crecer/autoservicio/";

  return (
    <>
      <div className="block pt-14 pb-[100px] lg:pb-[140px] xl:pb-[180px] relative">
        {isLoading && <GlobalLoading />}
        <iframe
          src={crecerMasUrl}
          title="CrecerMas"
          className="w-full h-screen border-0 rounded-lg"
          style={{ minHeight: "calc(100vh - 200px)" }}
          onLoad={handleIframeLoad}
          allow="same-origin"
        />
      </div>
    </>
  );
}

export default WithMainLayout(CrecerMas, "CrecerMas");